import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ICosellValidationState,
  TOptionalCheck,
} from 'src/manageAction/interfaces/ManageActionValidationSlices';

const initialState: ICosellValidationState = {
  optionalCheck: {},
  //Boolean values
  isCoSellValidationNeeded: false,
  cosellValidationNeeded: false,
  disableDealDetails: false,
  disablePartnerDetails: false,
  disablePartnerCountryAlone: false,
  enablePartnerCountry: false,
  disableMSXDataFields: false,
  isDoneStatusValid: false,
};

export const cosellValidationSlice = createSlice({
  name: 'cosellValidationSlice',
  initialState,
  reducers: {
    //use below action to update more state of the cosell validation
    updateCosellValidation: (state, action: PayloadAction<ICosellValidationState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateOptionalCheck: (state, action: PayloadAction<TOptionalCheck>) => {
      state.optionalCheck = action.payload;
    },
    updateisCoSellValidationNeeded: (state, action: PayloadAction<boolean>) => {
      state.isCoSellValidationNeeded = action.payload;
    },
    ValidationNeeded: (state, action: PayloadAction<boolean>) => {
      state.cosellValidationNeeded = action.payload;
    },
    updateDisableDealDetails: (state, action: PayloadAction<boolean>) => {
      state.disableDealDetails = action.payload;
    },
    updateDisablePartnerDetails: (state, action: PayloadAction<boolean>) => {
      state.disablePartnerDetails = action.payload;
    },
    updateDisablePartnerCountryAlone: (state, action: PayloadAction<boolean>) => {
      state.disablePartnerCountryAlone = action.payload;
    },
    updateEnablePartnerCountry: (state, action: PayloadAction<boolean>) => {
      state.enablePartnerCountry = action.payload;
    },
    updateDisableMSXDataFields: (state, action: PayloadAction<boolean>) => {
      state.disableMSXDataFields = action.payload;
    },
    updateIsDoneStatusValid: (state, action: PayloadAction<boolean>) => {
      state.isDoneStatusValid = action.payload;
    },
  },
});

export default cosellValidationSlice.reducer;

export const {
  updateCosellValidation,
  updateOptionalCheck,
  updateisCoSellValidationNeeded,
  ValidationNeeded,
  updateDisableDealDetails,
  updateDisablePartnerDetails,
  updateDisablePartnerCountryAlone,
  updateEnablePartnerCountry,
  updateDisableMSXDataFields,
  updateIsDoneStatusValid,
} = cosellValidationSlice.actions;
